import { ImageData } from '../../types';
import { Product } from '../../types/product';
import { getImageSrc, DEFAULT_IMAGE_QUALITY_PARAMETER } from './getImageSrc';

export const imagePresetsOfProductImage: [number, number][] = [
  [169, 132],
  [277, 216],
  [366, 275],
];

const sizeQueriesForProductListing = [
  '(max-width: 479px) 169px',
  '(min-width: 480px) 277px',
  '(min-width: 1250px) 366px',
];

export interface ImageSrcMediaQueryMapping {
  [key: string]: string[];
}

interface ProductImageConfig {
  quality: number;
}

const defaultConfig: ProductImageConfig = {
  quality: DEFAULT_IMAGE_QUALITY_PARAMETER,
};

export const getProductImageSrc = (
  PRODUCT_IMAGES_PATH: string,
  product: Product,
  config: ProductImageConfig = defaultConfig,
): ImageData => {
  const { quality } = config;
  const { partner, productId, images, title } = product;
  return getImageSrc(
    `${partner.id}/${productId}-${images[0]}`,
    imagePresetsOfProductImage,
    sizeQueriesForProductListing,
    `${PRODUCT_IMAGES_PATH}/`,
    title,
    quality,
  );
};
